import(/* webpackMode: "eager" */ "/vercel/path0/app/projects/PerfilUAM/page.tsx");
